import Immutable from 'immutable';
import { UPDATE_PAGE_PROGRESS } from './actions';
import { SET_MODULE_PROGRESS_FOR_COURSE } from '../ModuleProgress/actions';
import { BLOCKPAGE_DATA_LOADED_SUCCESS } from '../BlockPageUI/actions';

const DEFAULT_STATE = Immutable.fromJS({
  /*
  pagePath: {
    hasUserCommented: bool
  }
  */
});

const updateUserHasCommented = (state, pagePath, hasUserCommented) => {
  if (hasUserCommented === undefined) {
    return state;
  }

  return state.setIn([pagePath, 'hasUserCommented'], hasUserCommented);
};

export function PageProgress(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_MODULE_PROGRESS_FOR_COURSE: {
      const { moduleProgress } = action;

      let newState = state;
      moduleProgress.forEach((module) => {
        module.pages.forEach((page) => {
          const { hasUserCommented } = page;
          newState = newState.updateIn(
            [page.path, 'hasUserCommented'],
            (prevHasUserCommented) => {
              // don't override an existing 'true' value
              // getModuleProgressForUser only sets hasUserCommented to true
              // if the isCommentRequired is true
              // but here we need to know if the user has commented regardless
              return prevHasUserCommented || hasUserCommented;
            }
          );
        });
      });
      return newState;
    }
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      const { pagePath, hasUserCommented } = action;
      return updateUserHasCommented(state, pagePath, hasUserCommented);
    }
    case UPDATE_PAGE_PROGRESS: {
      const {
        pagePath,
        changes: { hasUserCommented },
      } = action;
      return updateUserHasCommented(state, pagePath, hasUserCommented);
    }
    default: {
      return state;
    }
  }
}
